'use strict';

var BreakdownChartDirective = function BreakdownChartDirective(Chart, Viewport) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/breakdown-chart.html'),
    controller: 'BreakdownChartController',
    scope: {
      mode: '=',
      classGrp: '=',
      chartData: '='
    },
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.viewportFormatters);
      scope.renderChartDataPresent = function renderChart(data, selectionSize) {
        chart.withLabel(scope.classGrp).render(data, selectionSize);
        viewport.render(data, selectionSize);
      };
      scope.setViewportSelection = function (selectionSize) {
        viewport.render(scope.chartData, selectionSize, scope.chartData.length);
      };
      viewport.on('rangechange', function (range) {
        chart.domainChange(range);
      });
    }
  };
};
BreakdownChartDirective.$inject = ['BreakdownChart', 'BreakdownChartVieport'];
module.exports = BreakdownChartDirective;